<template>
    <div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Tabs value="1">
            <TabPane label="基础信息" name="1">
                <Form label-position="left" :label-width="80" >
                    <FormItem label="id" v-if="data.id">
                        <Input v-model="data.id"  disabled></Input>
                    </FormItem>

                    <FormItem label="选手ID" v-if="$unit.filterGameids( [3,], game_id )">
                        <Input v-model="data.player_id"  disabled></Input>
                    </FormItem>

                    <FormItem label="队伍">
                        <Row>
                            <Col span="20" >
                                <teamSearch v-model="data.team" :game_id="game_id"></teamSearch>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="中文名称" v-if="$unit.filterGameids( [1,2,6,], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.name_zh" ></Input>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="英文名称" v-if="$unit.filterGameids( [1,2,6,], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.name_en" ></Input>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="中文简称" v-if="$unit.filterGameids( [1,2,6,], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.abbr_zh" ></Input>
                            </Col>
                        </Row>
                    </FormItem>
                    <FormItem label="中文简称" v-if="$unit.filterGameids( [1,2,6,], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.abbr_en" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="国家" v-if="$unit.filterGameids( [1,2,3], game_id )">
                        <Row>
                            <Col span="20" >
                                <countrySearch v-model="data.country" :game_id="game_id"></countrySearch>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="名称" v-if="$unit.filterGameids( [3], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.name" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="简称" v-if="$unit.filterGameids( [3], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.short_name" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="真名" v-if="$unit.filterGameids( [1,2,3], game_id )">
                        <Row>
                            <Col span="20" >
                                <Input v-model="data.real_name" ></Input>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="logo: ">
                        <Row>
                            <imgEditor v-model="data.logo" :prefix="$conf.games.img_prefix" :dir="$conf.games.games[game_id].img +  (game_id===3? '/player/head' : '/player') " 
                                :previewButton='true' :clearButton='true' cdn='games'>
                            </imgEditor>
                        </Row>
                    </FormItem>

                    <FormItem label="号位" v-if="$unit.filterGameids( [1,3, 6], game_id )">
                        <Row>
                            <Col span="20" >
                                <Select v-model="data.position" >
                                    <Option :value="0" key="0">未知</Option>
                                    <Option v-for="(item, index) in $conf.games.positions[game_id]" :value="item.id" :key="item.id">{{item.name}}</Option>
                                </Select>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="首发"  v-if="$unit.filterGameids( [1], game_id )">
                        <Row>
                            <Col span="20" >
                                <Select v-model="data.is_first" >
                                    <Option :value="0" key="0">未知</Option>
                                    <Option :value="1" key="1">首发</Option>
                                    <Option :value="2" key="2">替补</Option>
                                </Select>
                            </Col>
                        </Row>
                    </FormItem>

                    <FormItem label="生日" v-if="$unit.filterGameids( [1,2,3], game_id )">
                        <Row>
                            <Col span="20" >
                                <DatePicker 
                                    type="date" 
                                    format="yyyy-MM-dd" 
                                    style="width: 100%"
                                    v-model="birthday"
                                >
                                </DatePicker>
                            </Col>
                        </Row>
                    </FormItem>
                    
                    <FormItem label="删除">
                        <Row>
                            <Col span="20" >
                                <Select v-model="data.deleted" >
                                    <Option :value="1" key="1">是</Option>
                                    <Option :value="0" key="0">否</Option>
                                </Select>
                            </Col>
                        </Row>
                    </FormItem>
                </Form>
            </TabPane>
        </Tabs>

        <Row :gutter="16" align="middle">
            <Col span="12" style="text-align: left" >
                <Button type="default"  @click="cancle" long size="default">取消</Button>
            </Col>
            <Col span="12" style="text-align: right">
                <Button type="primary"  @click="save" long size="default">保存</Button>
            </Col>
        </Row>
    </div>
</template>
<script>

import { getPlayers, editPlayer } from '@/api/games/player';
import imgEditor from '@/components/img-editor/img-editor.vue';
import countrySearch from '../country/search.vue';
import teamSearch from '../team/search.vue';
import moment from 'moment';

export default {
    name: "player-edit",
    props: {
        game_id: Number,   // 运动id
        player_id: Number,   // 比赛id
    },
    components: {
        imgEditor,
        teamSearch,
        countrySearch
    },
    data () {
        let self = (window.x = this)
        return {
            obj_type: 1,
            type: 5, 
            spinShow: false,
            data: {
                game_id: self.game_id,
                country: {},
                team: {},
                birthday: 0, // parseInt( Date.parse(new Date())/1000 ),
            },
        }
    },
    methods: {
        // 获取分别的名称
        getTeamSide(){
            if (this.game_id == 1){
                return ['', '']
            }else if (this.game_id == 3 ){
                return ['天辉', '夜魇']
            }else{
                return ['', '']
            }
        },

        _init_data(){
            this.data = {
                game_id: this.game_id,
                country: {},
                team: {},
                birthday: 0, // parseInt( Date.parse(new Date())/1000 ),
            }
        },
        // 获取比赛的基础数据
        getData () {
            let self = this;
            this.spinShow = true;
            // 搜索日期
            if (self.player_id > 0){
                var params = {
                    game_id: self.game_id,
                    player_id: self.player_id,
                }
                getPlayers( params ).then(response => {
                    // console.log(response)
                    if (response.data.code == 0) {
                        if (response.data.data.list && response.data.data.list.length > 0){
                            this.data = response.data.data.list[0];
                        }else{
                            this.data = {}
                        }
                    } else {
                        self.$Message.error(response.data.msg)
                    }
                })
            }else{
                self._init_data();
            }
            self.spinShow = false;
        },
        // end 
        emit(func_name){
            this.$emit('closePage', func_name)
        },

        cancle(){
            let self = this;
            self.emit("cancle")
        },
        save() {
            let self = this;
            if (self.game_id == 1){
                // lol
                var params = {
                    id: self.data.id,
                    game_id: self.data.game_id || self.game_id,
                    name_en: self.data.name_en,
                    name_zh: self.data.name_zh,
                    abbr_en: self.data.abbr_en,
                    abbr_zh: self.data.abbr_zh,
                    real_name: self.data.real_name,
                    team_id: self.data.team.id,
                    country_id: self.data.country.id,
                    logo: self.data.logo,
                    is_first: self.data.is_first,
                    position: self.data.position,
                    birthday: self.data.birthday,
                    deleted: self.data.deleted,
                };
            }else if (self.game_id == 2){
                var params = {
                    id: self.data.id,
                    game_id: self.data.game_id || self.game_id,
                    name_en: self.data.name_en,
                    name_zh: self.data.name_zh,
                    abbr_en: self.data.abbr_en,
                    abbr_zh: self.data.abbr_zh,
                    real_name: self.data.real_name,
                    team_id: self.data.team.id,
                    country_id: self.data.country.id,
                    logo: self.data.logo,
                    birthday: self.data.birthday,
                    deleted: self.data.deleted,
                };
            }else if (self.game_id == 3){
                var params = {
                    id: self.data.id,
                    game_id: self.data.game_id || self.game_id,
                    player_id: self.data.player_id,
                    team_id: self.data.team.id,
                    country_id: self.data.country.id,
                    name: self.data.name,
                    short_name: self.data.short_name,
                    real_name: self.data.real_name,
                    logo: self.data.logo,
                    position: self.data.position,
                    birthday: self.data.birthday,
                    deleted: self.data.deleted,
                };
            }else if (self.game_id == 6){
                var params = {
                    id: self.data.id,
                    game_id: self.data.game_id || self.game_id,
                    name_en: self.data.name_en,
                    name_zh: self.data.name_zh,
                    short_name_en: self.data.abbr_en,
                    short_name_zh: self.data.abbr_zh,
                    team_id: self.data.team.id,
                    logo: self.data.logo,
                    position_id: self.data.position,
                    deleted: self.data.deleted,
                };
            }else{
                return
            }
            // console.log(params);
            editPlayer(params).then(response => {
                if (response.data.code == 0) {
                    this.$Message.success("保存成功")
                    self.emit("save")
                } else {
                    self.$Message.error(response.data.msg)
                }
            })
        },
    },
    mounted () {
    },
    watch: {
        'player_id': {
            handler(value){
                let self = this;
                if (value >= 0){
                    // console.log("Detail Get Data", value);
                    self.getData();
                };
            },
            deep: false,
	        immediate: false,  // 深度触发
        },
        // end 
    },
    computed: {
        birthday: {
            get: function () {
                if (this.data.birthday){
                    return moment.unix(this.data.birthday).toDate();
                }else{
                    return '' // parseInt( Date.parse(new Date())/1000 ) ;
                }
            },
            set: function (newValue) {
                this.data.birthday = moment(newValue).unix();
            }
        },
        
    }
}
</script>

<style scoped>
    /* @import "detail.css" */
</style>